export default [
  {
    path: 'communications',
    children: [
      {
        name: 'communications',
        path: '',
        component: () => import('./CommunicationsList.vue'),
        meta: { title: 'Communications' },
      },
      {
        name: 'create-communication',
        path: 'create',
        component: () => import('./CommunicationForm.vue'),
        meta: { title: 'New Communication' },
        props: {
          type: 'New',
        },
      },
      {
        name: 'edit-communication',
        path: ':id/edit',
        component: () => import('./CommunicationForm.vue'),
        meta: { title: 'Edit Communication' },
        props: (route) => ({
          type: 'Edit',
          id: route.params.id,
        }),
      },
      {
        name: 'view-communication',
        path: ':id/view',
        component: () => import('./CommunicationView.vue'),
        meta: { title: 'View Communication' },
        props: (route) => ({
          id: route.params.id,
        }),
      },
    ],
  },
]
